import { action } from '@ember/object';
import Route from '@ember/routing/route';
import { service } from '@ember/service';
import logger from 'donor-elf-web/lib/logger';
import RSVP from 'rsvp';
import ExpiredFundTokenError from '../../adapters/expired-fund-token-error';
import { isPresent } from '@ember/utils';

export default class FundRoute extends Route {
  @service abilities;
  @service campaignService;
  @service contactsCache;
  @service currentUser;
  @service fundsService;
  @service navbarSettings;
  @service router;
  @service settings;
  @service store;
  @service taskService;

  beforeModel(transition) {
    // replaced '/funds/selected-fund/*' with the user's selected fund
    if (transition.intent.url?.startsWith('/funds/selected-fund')) {
      let subPath = transition.intent.url.replace('/funds/selected-fund', '');
      this.router.transitionTo(
        `/funds/${this.currentUser.selectedFundId}${subPath}`,
      );
    } else if (
      transition.intent.url == null &&
      transition.intent.contexts?.join('') === 'selected-fund'
    ) {
      this.router.transitionTo(`/funds/${this.currentUser.selectedFundId}`);
    }
  }

  async model(params) {
    // expecting the browser will be hard-refreshed when switching funds so that
    // all the in-memory caching will be broke
    try {
      let fund = await this.store.findRecord('fund', params.fundId);
      this.fundsService.selectedFund = fund;
      await this.fundsService.populateSelectedFundToken();
      await Promise.all([
        this.settings.loadSettings(fund.id),
        this.contactsCache.loadContacts(),
        this.abilities.loadForFund(fund.id)
      ]);
      if (this.campaignService.campaignsEnabled) {
        await this.campaignService.load();
      }
      // start loading the taskService data but don't want on it to finish
      this.taskService.load({ forceLoad: true });
    } catch (reason) {
      let firstError = reason.errors?.slice()?.[0]
      if (firstError?.status === '404') {
        return this.router.transitionTo('funds.no-access');
      }
      throw reason;
    }
  }

  afterModel() {
    this.navbarSettings.topNavbarComponent = 'top-navbar-fund';
  }

  @action
  willTransition(transition) {
    let intentName = transition.intent?.name || '';
    if (intentName.length > 0 && intentName.indexOf('funds.') !== 0) {
      this.navbarSettings.topNavbarComponent = '';
    }
  }

  @action
  error(error, transition) {
    if (error instanceof ExpiredFundTokenError) {
      logger.error(
        `invalid fund token while going to route: ${transition.intent.name}`,
      );
    }
    return true;
  }

  // for some reason when going to the Journal, the `deactivate()` method is called even though
  // it's not leaving the route, so we have to check if there is an active journal in
  // the `activate` method too.
  activate() {
    if (this.fundsService.dashboard?.hasActiveJournal) {
      this.navbarSettings.showActiveJournalButton = true;
    }
  }

  deactivate() {
    if (this.navbarSettings.showActiveJournalButton) {
      this.navbarSettings.showActiveJournalButton = false;
    }
  }
}
